/**
 * Module definition houses global utility services
 *
 * @module services.error
 */
angular.module('services.utility', [
  'services.utility.DeepFunctionService',
  'services.utility.LTIService'
]);
